import { useTranslation } from 'react-i18next'

export const useRules = () => {
  const { t } = useTranslation()

  const password = (value: string) =>
    !value || /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]{8,31}$/.test(value) || `${t('validate.password')}`

  const rules = { password }

  return { rules }
}
